import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import { APIS, SF_LCNE_USR_SRCH, SG_LCNE_USR_LIST, URLS } from "@/tra/tancis/ptli/usr/lcneusraprv/services/PtliLcneUsrAprvService";

/*
 * License User Approval List
 * !== 면허 사용자 승인 목록 ==!
 */
export const PTLI0907001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptli0025", "auth_eswi0004", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();    // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate();       // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast();          // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "LCM0001" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // License User List Search !== 면허 사용자 목록 검색 ==!
        lcneUsrListSrch: useForm({
            defaultSchema: SF_LCNE_USR_SRCH,
            defaultValues: {
                bsopPrcssStat: "U",
                ...(pgeStore?.form || {}),
            },
        })
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // License User List !== 면허 사용자 목록 ==!
        lcneUsrList: useGrid({
            defaultSchema: SG_LCNE_USR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size
        })
    };

    /*
    * Declaration Fetch
    * !== Fetch 정의 ==!
    */
    const fetch = {
        //Check License User List !==  면허 사용자 목록 조회==!
        getLcneUsrList: useFetch({
            api: (page = grid.lcneUsrList.page) => APIS.getLcneUsrList(form.lcneUsrListSrch.getValues(), page, grid.lcneUsrList.size),
            enabled: comnUtils.isEmpty(form.lcneUsrListSrch.errors),
            key: [grid.lcneUsrList.page, grid.lcneUsrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.lcneUsrListSrch.getValues(),
                    page: grid.lcneUsrList.page,
                    size: grid.lcneUsrList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }) // Failed to select. !== 조회가 실패하였습니다. ==!
            , showToast: true
        })
    }
    const render = {
        cell: {
            coNm: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link to={`/ptli/usr/lcneusraprv/ptli0907002q/${rowValues.lcneCoAplyId}`}>{value}</Link>
                )
            }
        }
    }

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: (page: number = 0) => {
            grid.lcneUsrList.setPage(page);
            fetch.getLcneUsrList.fetch(page);
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick(pgeStore?.page);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.lcneUsrListSrch.schema.lcneTpCd} />
                            <Group.Control {...form.lcneUsrListSrch.schema.coTin} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lcneUsrListSrch.schema.coNm} />
                            <Group.Control {...form.lcneUsrListSrch.schema.bsopPrcssStat} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.lcneUsrListSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={() => { handler.onSrchBtnClick() }} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.lcneUsrList.grid} data={fetch.getLcneUsrList.data?.lcneUsrList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    )
}